import axios from '@/utils/axiosHelper';

// 初始化数据(含授权)
export const onGetInitDataAPI = (params) => {
  return axios({ url: '/snail/test', method: 'GET', params }, { interceptResultCode: false });
};



// WEBPACK FOOTER //
// ./src/pages/snail/newYearDay/api.js